import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import Demovideo from "../../assets/Demovideo.mp4";
import PropTypes from "prop-types";
import "../demo/demo.css";
export default function Demo(props) {
  const [open, openModal] = React.useState(false);
  const [error, setError] = React.useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const handleClickOpen = () => {
    openModal(!open);
  };
  const handleClose = () => {
    openModal(!open);
    let Submitbtn = document.getElementById("formsubmit");

    Submitbtn.click();
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const submitDemoForm = (e) => {
    if (!firstName || !lastName || !email || !companyName || !mobileNo) {
      setError("Please fill all the required fields");
    } else {
      handleClickOpen();
    }
  };

  function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  }

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
  };

  return (
    <React.Fragment>
      <div className="demo-background">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexDirection: "column",
            padding: "150px 215px",
          }}
        >
          <h2
            style={{
              fontSize: "40px",
              color: "#fff",
              fontFamily: "pipins",
              fontWeight: 600,
            }}
          >
            Online Demo
          </h2>
        </div>
      </div>

      <div className="support-outer-box">
        <BootstrapDialog
          style={{ alignItems: "center", alignContent: "center" }}
          onClose={() => {
            let Submitbtn = document.getElementById("formsubmit");
            Submitbtn.click();
            openModal(false);
          }}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <DialogContent dividers>
            <BootstrapDialogTitle>
              Demo Video
              <p style={{ fontSize: "12px", fontFamily: "Poppins" }}>
                Here are some of the videos help to understand products
              </p>
            </BootstrapDialogTitle>
            <Typography gutterBottom>
              <iframe
                className="modal__video-style"
                loading="lazy"
                width="560"
                height="315"
                src={Demovideo}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              ></iframe>
            </Typography>
          </DialogContent>
        </BootstrapDialog>
      </div>
      <p
        style={{
          fontWeight: "600",
          color: "#00327E",
          fontSize: "15px",
        }}
      ></p>
      <div className="demo-card-container">
        <div style={{ margin: "40px" }}>
          <h2
            style={{
              color: "#263238",
              fontSize: "30px",
              fontFamily: "popins",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Welcome
          </h2>
          <p
            style={{
              color: "#263238",
              fontSize: "20px",
              fontFamily: "popins",
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            {" "}
            Please Fill Information
          </p>
          <div
            id="crmWebToEntityForm"
            className="zcwf_lblLeft crmWebToEntityForm"
            style={{ backgroundColor: "white", color: "black", maxWidth: 600 }}
          >
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
            <meta httpEquiv="content-type" content="text/html;charset=UTF-8" />
            <form
              action="https://crm.zoho.com/crm/WebToContactForm"
              name="WebToContacts129652000050014012"
              method="POST"
              onsubmit='javascript:document.charset="UTF-8"; return checkMandatory129652000050014012()'
              acceptCharset="UTF-8"
            >
              <input
                type="text"
                style={{ display: "none" }}
                name="xnQsjsdp"
                defaultValue="485a6233e33ff9469c544f480893639484d1a7e2a844f16c4c645f791586cb5c"
              />
              <input type="hidden" name="zc_gad" id="zc_gad" defaultValue="" />
              <input
                type="text"
                style={{ display: "none" }}
                name="xmIwtLD"
                defaultValue="832a349b02accc5cfad05c9d613653f4b4597955890985a19b78827c72d2d95b"
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="actionType"
                defaultValue="Q29udGFjdHM="
              />
              <input
                type="text"
                style={{ display: "none" }}
                name="returnURL"
                defaultValue="https://www.keylong.io/"
              />
              {/* Do not remove this code. */}
              <style
                dangerouslySetInnerHTML={{
                  __html:
                    "\nhtml,body{\n      margin: 0px;\n}\n#crmWebToEntityForm.zcwf_lblLeft {\n      width:100%;\n      padding: 25px;\n      margin: 0 auto;\n      box-sizing: border-box;\n}\n#crmWebToEntityForm.zcwf_lblLeft * {\n      box-sizing: border-box;\n}\n#crmWebToEntityForm{text-align: left;}\n#crmWebToEntityForm * {\n      direction: ltr;\n}\n.zcwf_lblLeft .zcwf_title {\n      word-wrap: break-word;\n      padding: 0px 6px 10px;\n      font-weight: bold;\n}\n.zcwf_lblLeft .zcwf_col_fld input[type=text], .zcwf_lblLeft .zcwf_col_fld textarea {\n      width: 60%;\n      border: 1px solid #c0c6cc !important;\n      resize: vertical;\n      border-radius: 2px;\n      float: left;\n}\n.zcwf_lblLeft .zcwf_col_lab {\n      width: 30%;\n      word-break: break-word;\n      padding: 0px 6px 0px;\n      margin-right: 10px;\n      margin-top: 5px;\n      float: left;\n      min-height: 1px;\n}\n.zcwf_lblLeft .zcwf_col_fld {\n      float: left;\n      width: 68%;\n      padding: 0px 6px 0px;\n      position: relative;\n      margin-top: 5px;\n}\n.zcwf_lblLeft .zcwf_privacy{padding: 6px;}\n.zcwf_lblLeft .wfrm_fld_dpNn{display: none;}\n.dIB{display: inline-block;}\n.zcwf_lblLeft .zcwf_col_fld_slt {\n      width: 60%;\n      border: 1px solid #ccc;\n      background: #fff;\n      border-radius: 4px;\n      font-size: 14px;\n      float: left;\n      resize: vertical;\n      padding: 2px 5px;\n}\n.zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after {\n      content: '';\n      display: table;\n      clear: both;\n}\n.zcwf_lblLeft .zcwf_col_help {\n      float: left;\n      margin-left: 7px;\n      font-size: 14px;\n      max-width: 35%;\n      word-break: break-word;\n}\n.zcwf_lblLeft .zcwf_help_icon {\n      cursor: pointer;\n      width: 16px;\n      height: 16px;\n      display: inline-block;\n      background: #fff;\n      border: 1px solid #c0c6cc;\n      color: #c1c1c1;\n      text-align: center;\n      font-size: 11px;\n      line-height: 16px;\n      font-weight: bold;\n      border-radius: 50%;\n}\n.zcwf_lblLeft .zcwf_row {margin: 15px 0px;}\n.zcwf_lblLeft .formsubmit {\n      margin-right: 5px;\n      cursor: pointer;\n      color: var(--baseColor);\n      font-size: 14px;\n}\n.zcwf_lblLeft .zcwf_privacy_txt {\n      width: 90%;\n      color: rgb(0, 0, 0);\n      font-size: 14px;\n      font-family: Arial;\n      display: inline-block;\n      vertical-align: top;\n      color: var(--baseColor);\n      padding-top: 2px;\n      margin-left: 6px;\n}\n.zcwf_lblLeft .zcwf_button {\n      font-size: 14px;\n      color: var(--baseColor);\n      border: 1px solid #c0c6cc;\n      padding: 3px 9px;\n      border-radius: 4px;\n      cursor: pointer;\n      max-width: 120px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n}\n.zcwf_lblLeft .zcwf_tooltip_over{\n      position: relative;\n}\n.zcwf_lblLeft .zcwf_tooltip_ctn{\n      position: absolute;\n      background: #dedede;\n      padding: 3px 6px;\n      top: 3px;\n      border-radius: 4px;word-break: break-word;\n      min-width: 100px;\n      max-width: 150px;\n      color: var(--baseColor);\n      z-index: 100;\n}\n.zcwf_lblLeft .zcwf_ckbox{\n      float: left;\n}\n.zcwf_lblLeft .zcwf_file{\n      width: 55%;\n      box-sizing: border-box;\n      float: left;\n}\n.clearB:after{\n      content:'';\n      display: block;\n      clear: both;\n}\n@media all and (max-width: 600px) {\n      .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld {\n            width: auto;\n            float: none !important;\n      }\n      .zcwf_lblLeft .zcwf_col_help {width: 40%;}\n}\n",
                }}
              />
              {/* <div
                className="zcwf_title"
                style={{ maxWidth: 600, color: "black" }}
              >
                Keylong Demo Form
              </div> */}
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Last_Name">
                    Last Name<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Last_Name"
                    name="Last Name"
                    maxLength={30}
                    onClick={setLastName}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="First_Name">
                    First Name<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="First_Name"
                    name="First Name"
                    maxLength={30}
                    onClick={setFirstName}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Mobile">
                    Mobile<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Mobile"
                    onClick={setMobileNo}
                    name="Mobile"
                    maxLength={15}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Email">
                    Business Email<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    ftype="email"
                    id="Email"
                    name="Email"
                    maxLength={100}
                    onClick={setEmail}
                  />
                  {/* <div className="zcwf_col_help">
                    {" "}
                    <span
                      title="abc@inventum.net"
                      style={{
                        cursor: "pointer",
                        width: 16,
                        height: 16,
                        display: "inline-block",
                        background: "#fff",
                        border: "1px solid #c0c6cc",
                        color: "#c1c1c1",
                        textAlign: "center",
                        fontSize: 11,
                        lineHeight: 16,
                        fontWeight: "bold",
                        borderRadius: "50%",
                      }}
                      onclick="tooltipShow129652000050014012(this)"
                    >
                      ?
                    </span> */}
                  {/* <div
                      className="zcwf_tooltip_over"
                      style={{ display: "none" }}
                    >
                      <span className="zcwf_tooltip_ctn">abc@inventum.net</span>
                    </div> */}
                  {/* </div> */}
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Account_Name">
                    Company Name<span style={{ color: "red" }}>*</span>
                  </label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Account_Name"
                    name="Account Name"
                    maxLength={30}
                    onClick={setCompanyName}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Mailing_Country">Mailing Country</label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Mailing_Country"
                    name="Mailing Country"
                    maxLength={50}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Mailing_State">Mailing State</label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Mailing_State"
                    name="Mailing State"
                    maxLength={50}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Mailing_City">Mailing City</label>
                </div>
                <div className="zcwf_col_fld">
                  <input
                    type="text"
                    id="Mailing_City"
                    name="Mailing City"
                    maxLength={50}
                  />
                  <div className="zcwf_col_help" />
                </div>
              </div>
              <div className="zcwf_row wfrm_fld_dpNn">
                <div
                  className="zcwf_col_lab"
                  style={{ fontSize: 14, fontFamily: "Arial" }}
                >
                  <label htmlFor="Lead_Source">Lead Source</label>
                </div>
                <div className="zcwf_col_fld">
                  <select
                    className="zcwf_col_fld_slt"
                    id="Lead_Source"
                    name="Lead Source"
                  >
                    <option value="-None-">-None-</option>
                    <option selected="" value="Website">
                      Website
                    </option>
                    <option value="Referral">Referral</option>
                    <option value="Email Campaign">Email Campaign</option>
                    <option value="Telemarketing">Telemarketing</option>
                    <option value="Advert / PR">Advert / PR</option>
                    <option value="Show / Seminar">Show / Seminar</option>
                    <option value="Facebook">Facebook</option>
                    <option value="Twitter">Twitter</option>
                    <option value="Google+">Google+</option>
                  </select>
                  <div className="zcwf_col_help" />
                </div>
              </div>
              {error && (
                <div style={{ color: "red", textAlign: "center" }}>
                  {`*` + error}
                </div>
              )}
              <div className="zcwf_row">
                <div className="zcwf_col_lab" />
                <div className="zcwf_col_fld">
                  <Button
                    style={{
                      backgroundColor: "#0047B3",
                      color: "#fff",
                    }}
                    defaultValue="Submit"
                    onClick={(e) => submitDemoForm(e)}
                  >
                    Submit
                  </Button>
                  <input
                    style={{ display: "none" }}
                    type="submit"
                    id="formsubmit"
                    className="formsubmit zcwf_button"
                    defaultValue="Submit"
                    title="Submit"
                  />
                  <input
                    type="reset"
                    className="zcwf_button"
                    name="reset"
                    defaultValue="Reset"
                    title="Reset"
                  />
                </div>
              </div>
              {/* Do not remove this --- Analytics Tracking code starts */}
              {/* Do not remove this --- Analytics Tracking code ends. */}
            </form>
          </div>
        </div>
      </div>
      <div style={{ height: "100vh " }}></div>
    </React.Fragment>
  );
}
